
import React from "react";
import { format } from "date-fns";
import { useAuth } from "@/contexts/AuthContext";
import { Zap } from "lucide-react";

const MessageWidget: React.FC = () => {
  const { profile } = useAuth();
  const todayFormatted = format(new Date(), "MMMM d, yyyy");
  
  // Get first name from full name
  const firstName = profile?.name ? profile.name.split(' ')[0] : 'Athlete';

  return (
    <div className="dashboard-hero mb-6">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-secondary/20 rounded-full translate-y-1/2 -translate-x-1/2" />
      
      <div className="relative z-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          {/* Date badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1 mb-3">
            <span className="text-xs font-bold text-white/90 uppercase tracking-wider">{todayFormatted}</span>
          </div>
          
          {/* Greeting */}
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-white tracking-tight">
            Welcome back, {firstName}!
          </h2>
          <p className="text-white/80 text-sm mt-1 max-w-md">
            Stay on top of your recruiting journey. Coaches are looking for athletes like you.
          </p>
        </div>
        
        {/* Motivational element */}
        <div className="flex items-center gap-2 bg-secondary/20 backdrop-blur-sm rounded-xl px-4 py-3 border border-secondary/30">
          <Zap className="h-5 w-5 text-secondary" />
          <span className="text-sm font-bold text-white">Keep pushing forward!</span>
        </div>
      </div>
    </div>
  );
};

export default MessageWidget;
